module.exports = coreApis.ajax;